import SuperDashboard from "../views/super/dashboard/Dashboard";
import Icons from "../views/Icons/Icons";
import Area from "../views/super/areas/Areas";
import AddArea from "../views/super/areas/AddArea";
import User from "../views/super/users/Users";
import EditUser from "../views/super/users/EditUser";
import EditArea from "../views/super/areas/EditArea";
import ProfileDetails from "../components/account/ProfileDetails";
import EditPackage from "../views/super/packages/EditPackage";
import AddPackage from "../views/super/packages/AddPackage";
import Packages from "../views/super/packages/Packages";
import Template from "../views/super/template/Template";
import EditTemplate from "../views/super/template/EditTemplate";

const Super = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: <SuperDashboard/>,
    role: 'superAdmin',
    icon: "nc-icon nc-bank",
    show: true 
  },

  {
    path: "/area",
    name: "Amenities",
    icon: "nc-icon nc-diamond",
    component: <Area />,
    role: 'superAdmin',
    layout: "/area",
    show: true 
  },
  {
    path: "/user",
    name: "Users",
    icon: "nc-icon nc-diamond",
    component: <User />,
    role: 'superAdmin',
    layout: "/user",
    show: true 
  },
  {
    path: "/user/edit/:id",
    name: "Edit User",
    component: <EditUser />,
    role: 'superAdmin',
    layout: "/user",
    show: false
  },
  {
    path: "/account",
    name: "Account",
    icon: "nc-icon nc-diamond",
    component: <ProfileDetails />,
    role: 'superAdmin',
    show: false 
  },
  {
    path: "/area/add",
    name: "Add Area",
    component: <AddArea />,
    role: 'superAdmin',
    layout: "/area/add",
    show: false 
  },
  {
    path: "/area/edit/:id",
    name: "Edit Area",
    component: <EditArea />,
    role: 'superAdmin',
    layout: "/area/edit",
    show: false 
  },

  {
    path: "/package",
    name: "Packages",
    icon: "nc-icon nc-diamond",
    component: <Packages />,
    role: 'superAdmin',
    layout: "/package",
    show: true 
  },

  {
    path: "/package/add",
    name: "Add Package",
    component: <AddPackage />,
    role: 'superAdmin',
    layout: "/package/add",
    show: false 
  },
  {
    path: "/package/edit/:id",
    name: "Edit Package",
    component: <EditPackage />,
    role: 'superAdmin',
    layout: "/package/edit",
    show: false 
  },

  {
    path: "/template",
    name: "Templates",
    icon: "nc-icon nc-diamond",
    component: <Template />,
    role: 'superAdmin',
    show: true 
  },
  {
    path: "/template/edit/:id",
    name: "Edit Template",
    component: <EditTemplate />,
    role: 'superAdmin',
    show: false 
  },
];
export default Super;
